import { Namespace, useDescribeNamespaceQuery } from 'src/generated/graphql';

export interface UseNamespacePageDataResult {
  namespace: Namespace | undefined;
  namespaceLoading: boolean;
  /** Error from the namespace query (use for namespace header section). */
  namespaceError: Error | undefined;
}

/** Fetches namespace details. String groups data is managed separately
 * by the useStringGroupsData hook. */
export function useNamespacePageData(
  namespaceId: string | undefined,
): UseNamespacePageDataResult {
  const {
    data: namespaceData,
    loading: namespaceLoading,
    error: namespaceError,
  } = useDescribeNamespaceQuery({
    variables: { namespaceId: namespaceId ?? '' },
    skip: !namespaceId,
  });

  const namespace = namespaceData?.describeNamespace.namespace;

  return {
    namespace,
    namespaceLoading,
    namespaceError,
  };
}
